export const getStudentWorkflowCardFromPacket = (packet) => {
    if (!packet || typeof packet !== 'object') return null

    const packetData = packet.data
    const candidate = packetData && typeof packetData === 'object'
        ? packetData
        : packet._doc && typeof packet._doc === 'object'
            ? packet._doc
            : packet
    const todoId = String(candidate?.todoId || '').trim()

    return todoId ? candidate : null
}

export const upsertStudentWorkflowCard = (cards, newCard) => {
    const safeCards = (Array.isArray(cards) ? cards : []).filter(
        (card) => card && typeof card === 'object'
    )
    const card = getStudentWorkflowCardFromPacket(newCard)
    if (!card) return safeCards

    const cardId = String(card.todoId).trim()
    const existingIndex = safeCards.findIndex(
        (existingCard) => String(existingCard?.todoId || '').trim() === cardId
    )
    if (existingIndex === -1) return [...safeCards, card]

    return safeCards.map((existingCard, index) => (
        index === existingIndex ? card : existingCard
    ))
}
